import { SHStack } from "@components/design-systems";
import { useFeeCalculatorInputField } from "@hooks/useFeeCalculatorInputField";
import { FeeCalculatorRenderFieldProps } from "@models/platform-analysis/entities/steps/fee";
import { memo } from "react";
import { FeeCalculatorNumericInputController } from "../../controllers/numeric-input-controller";

export const CalculatorFieldInput = memo(
  ({ fieldConfig, disabled }: FeeCalculatorRenderFieldProps) => {
    const { singleVariableName, fieldType, linkedFieldVariableName } =
      fieldConfig;

    const { fieldPath, fieldName } = useFeeCalculatorInputField(
      singleVariableName,
      linkedFieldVariableName,
    );

    return (
      <SHStack width={"100%"} height={"100%"} justifyContent={"flex-end"}>
        <FeeCalculatorNumericInputController
          resetOnUnmount={true}
          fieldType={fieldType}
          fieldPath={fieldPath}
          label={fieldName}
          disabled={disabled}
        />
      </SHStack>
    );
  },
);
